/* eslint-disable -- disabled during migration, will be re-enabled in a follow-up PR */
import React from 'react';
import { styled } from '@compiled/react';

const ConnectorLogoStyle = styled.div<{ logo: string }>`
	background-image: url(${(props) => props.logo});
	background-repeat: no-repeat;
	background-position: 5% center;
	background-size: contain;
	width: 100%;
	height: 100%;
`;

interface ConnectorLogoProps {
	logo: string;
}

export const ConnectorLogo: React.FC<ConnectorLogoProps> = ({ logo, ...props }) => (
	<ConnectorLogoStyle logo={logo} {...props} />
);
